export const LanguageOptions = {
    fi: 'fi' as const,
    en: 'en' as const
};
export type Language = typeof LanguageOptions.fi | typeof LanguageOptions.en;
// start of PropertyInfo properties
export const BalconyOptions = {
    balcony: 'balcony' as const,
    no: 'no' as const,
    notSure: 'notSure' as const,
    glass: 'glass' as const,
    protruding: 'protruding' as const,
    balconet: 'balconet' as const
};
export type Balcony = typeof BalconyOptions.notSure | typeof BalconyOptions.no | typeof BalconyOptions.balcony | typeof BalconyOptions.glass | typeof BalconyOptions.protruding | typeof BalconyOptions.balconet;
export const RoomOptions = {
    '1h': '1h' as const,
    '2h': '2h' as const,
    '3h': '3h' as const,
    '4h': '4h' as const,
    '5h': '5h' as const,
    '+5h': '+5h' as const
};
export type Rooms = typeof RoomOptions['1h'] | typeof RoomOptions['2h'] | typeof RoomOptions['3h'] | typeof RoomOptions['4h'] | typeof RoomOptions['5h'] | typeof RoomOptions['+5h'];
export const KitchenOptions = {
    K: 'K' as const,
    KK: 'KK' as const,
    KT: 'KT' as const,
    AK: 'AK' as const,
    TUPAK: 'TUPAK' as const,
    other: 'other' as const
};
export type Kitchen = typeof KitchenOptions.K | typeof KitchenOptions.KK | typeof KitchenOptions.KT | typeof KitchenOptions.AK | typeof KitchenOptions.TUPAK | typeof KitchenOptions.other;
export const ConditionOptions = {
    excellent: 'excellent' as const,
    good: 'good' as const,
    satisfactory: 'satisfactory' as const
};
export type Condition = typeof ConditionOptions.good | typeof ConditionOptions.excellent | typeof ConditionOptions.satisfactory;
export const StorageOptions = {
    notSure: 'notSure' as const,
    no: 'no' as const,
    attic: 'attic' as const,
    cage: 'cage' as const,
    room: 'room' as const
};
export type Storage = typeof StorageOptions.notSure | typeof StorageOptions.no | typeof StorageOptions.attic | typeof StorageOptions.cage | typeof StorageOptions.room;
// end of property info
// building info
export const BuildingTypeOptions = {
    apartmentBuilding: 'apartmentBuilding' as const,
    rowHouse: 'rowHouse' as const,
    loft: 'loft' as const,
    detached: 'detached' as const,
    semiDetached: 'semiDetached' as const
};
export type BuildingType = typeof BuildingTypeOptions.apartmentBuilding | typeof BuildingTypeOptions.rowHouse | typeof BuildingTypeOptions.loft | typeof BuildingTypeOptions.detached | typeof BuildingTypeOptions.semiDetached;
// end of building info
// start of AdditionalProperties types
export const SaunaOptions = {
    notSure: 'notSure' as const,
    no: 'no' as const,
    own: 'own' as const,
    shared: 'shared' as const
};
export type Sauna = typeof SaunaOptions.notSure | typeof SaunaOptions.no | typeof SaunaOptions.own | typeof SaunaOptions.shared;
export const ParkingOptions = {
    notSure: 'notSure' as const,
    no: 'no' as const,
    streetParking: 'streetParking' as const,
    ownGarage: 'ownGarage' as const,
    sharedGarage: 'sharedGarage' as const,
    parkingLot: 'parkingLot' as const
};
export type Parking = typeof ParkingOptions.notSure | typeof ParkingOptions.no | typeof ParkingOptions.streetParking | typeof ParkingOptions.ownGarage | typeof ParkingOptions.sharedGarage | typeof ParkingOptions.parkingLot;
export const CarHeatingSocketOptions = {
    notSure: 'notSure' as const,
    no: 'no' as const,
    yes: 'yes' as const
};
export type CarHeatingSocket = typeof CarHeatingSocketOptions.notSure | typeof CarHeatingSocketOptions.no | typeof CarHeatingSocketOptions.yes;
export const DishwasherOptions = {
    yes: 'yes' as const,
    installable: 'installable' as const,
    no: 'no' as const
};
export type Dishwasher = typeof DishwasherOptions.no | typeof DishwasherOptions.yes | typeof DishwasherOptions.installable;
export const LaundryMachineOptions = {
    yes: 'yes' as const,
    installable: 'installable' as const,
    no: 'no' as const
};
export type LaundryMachine = typeof LaundryMachineOptions.no | typeof LaundryMachineOptions.yes | typeof LaundryMachineOptions.installable;
export const HeatingOptions = {
    notSure: 'notSure' as const,
    electric: 'electric' as const,
    geothermal: 'geothermal' as const,
    district: 'district' as const,
    exhaustAir: 'exhaustAir' as const,
    other: 'other' as const
};
export type Heating = typeof HeatingOptions.notSure | typeof HeatingOptions.electric | typeof HeatingOptions.geothermal | typeof HeatingOptions.district | typeof HeatingOptions.exhaustAir | typeof HeatingOptions.other;
// end of additional props
// ApartmentConfirmation
export const AnnouncementTypeOptions = {
    minimal: 'minimal' as const,
    regular: 'regular' as const
};
export type AnnouncementType = typeof AnnouncementTypeOptions.regular | typeof AnnouncementTypeOptions.minimal;
export const RentPeriodOptions = {
    formerlyValid: 'formerlyValid' as const,
    temporary: 'temporary' as const
};
export type RentPeriod = typeof RentPeriodOptions.formerlyValid | typeof RentPeriodOptions.temporary;
export const SecurityDepositOptions = {
    oneMonth: 'oneMonth' as const,
    twoMonths: 'twoMonths' as const,
    threeMonths: 'threeMonths' as const,
};
export type SecurityDeposit = typeof SecurityDepositOptions.oneMonth | typeof SecurityDepositOptions.twoMonths | typeof SecurityDepositOptions.threeMonths;
export const NoticeTimeOptions = {
    threeMonths: 'threeMonths' as const,
    sixMonths: 'sixMonths' as const,
    twelveMonths: 'twelveMonths' as const,
    none: 'none' as const,
};
export type NoticeTime = typeof NoticeTimeOptions.threeMonths | typeof NoticeTimeOptions.sixMonths | typeof NoticeTimeOptions.twelveMonths | typeof NoticeTimeOptions.none;
export const WaterFeeBasisOptions = {
    perTenant: 'perTenant' as const,
    perApartment: 'perApartment' as const,
    metered: 'metered' as const,
    included: 'included' as const
};
export type WaterFeeBasis = typeof WaterFeeBasisOptions.perTenant | typeof WaterFeeBasisOptions.perApartment | typeof WaterFeeBasisOptions.metered | typeof WaterFeeBasisOptions.included;
export const PetsAllowedOptions = {
    yes: 'yes' as const,
    no: 'no' as const,
    negotiate: 'negotiate' as const
};
export type PetsAllowed = typeof PetsAllowedOptions.yes | typeof PetsAllowedOptions.no | typeof PetsAllowedOptions.negotiate;
